import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const ConceptoImpuestosRetencionesIeps = ({ data = {}, onChange }) => {

  const handleImpuestosTipoChange = (event) => {
    const { value, checked } = event.target;

    onChange({
      ...data,
      TipoFactor: checked ? value : undefined
    });
  }

  const handleTasaCuotaChange = (event) => {
    const { name, value } = event.target;

    onChange({
      ...data,
      [name]: value
    });
  }

  return (
    <div className="mt-2">
      <Row>
        <Col>
          IEPS
        </Col>
      </Row>

      <Row className="mt-1 form-inline">
        <Col>
          <Form.Check
            type='checkbox'
            id="retenciones_ieps_tasa"
            name="retenciones_ieps_tipo"
            label="Tasa"
            value="Tasa"
            custom={ true }
            checked={ data.TipoFactor === 'Tasa' }
            onChange={ handleImpuestosTipoChange }
          />

          { data.TipoFactor === 'Tasa' && (
            <Form.Control type="number"
              name="TasaOCuota"
              label=" "
              min="0"
              max="16"
              className="text-right"
              placeholder={ data.TipoFactor }
              value={ data.TasaOCuota || '' }
              onChange={ handleTasaCuotaChange }
            />
          )}
        </Col>
      </Row>


    </div>
  );
}

export default ConceptoImpuestosRetencionesIeps;
